import { Typography } from "antd"
import { useEffect, useState } from "react"
import { t } from "../../../languages/i18n"
import AccountManagementProfile from "./AccountManagementProfile"

const { Title } = Typography

const Profile = () => {
  const [userInfo, setUserInfo] = useState({
    username: "",
    firstName: "",
    lastName: "",
    nickname: "",
    email: "",
    website: "",
    avatar: {},
  })

  useEffect(() => {
    const storedUser = localStorage.getItem("user")
    if (storedUser) {
      setUserInfo(JSON.parse(storedUser))
    }
  }, [])

  const updateUserInfo = (updatedInfo: Partial<typeof userInfo>) => {
    setUserInfo(prev => {
      const newUserInfo = { ...prev, ...updatedInfo }
      localStorage.setItem("user", JSON.stringify(newUserInfo))
      return newUserInfo
    })
  }

  return (
    <div className="p-4 rounded-sm">
      <div className="flex py-1 items-center justify-between">
        <div className="flex space-x-4 items-center">
          <Title level={2} className="m-0">
            {t("Profile")}
          </Title>
        </div>
      </div>
      <AccountManagementProfile userInfo={userInfo} updateUserInfo={updateUserInfo} />
    </div>
  )
}

export default Profile
